module.exports = __webpack_public_path__ + "img/13c42fdba827f565d98345385d332f5a.png";